<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `transaction/placement-reason/${inputs.id}` : `transaction/placement-reason`"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_reason" class="col-sm-3 mb-0">
						Reason
					</label>
					<app-input
						id="inputs_reason"
						class="col-sm-9"
						type="search-select"
						:list="reasonLists"
						v-model="inputs.reason_id"
						placeholder="Reason"
						required
					/>
				</div>
                <div class="form-group row align-items-center">
					<label for="inputs_comment" class="col-sm-3 mb-0">
						Comment (by Academic)
					</label>
					<app-input
						id="inputs_comment"
						class="col-sm-9"
						type="text"
						v-model="inputs.comment"
						placeholder="Comment (by Academic)"
						required
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "DirectPlacementTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		placementId: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			preloader: false,
			reasonLists: [],
			inputs: {
				placement_id: this.placementId,
			},
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
		this.fetchData()
	},
	methods: {
		async fetchData() {
			try {
				if (this.selectedUrl) {
					this.modalTitle = this.$t("edit");
					this.preloader = true;
				}

				let [reasonResponse] = await Promise.all([
					axios.get("/master/reason"),
				]);

				reasonResponse.data.data.forEach((item) => {
					this.reasonLists.push({
						id: item.id,
						value: item.name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
